import React from 'react'
import { SketchPicker } from 'react-color'
import Switch from '@material-ui/core/Switch'
import Slider from '@material-ui/lab/Slider'
import { constrain } from '../../utils';

export default class BackgroundEditor extends React.Component {

  onCustomBackgroundUrl = () => {
    const {onBackgroundOptionsChange} = this.props;
    onBackgroundOptionsChange(this.customBackgroundImageUrl.value, 'customImage')
  }

  render() {
    const {
      onBackgroundOptionsChange: onChange,
      backgroundOptions,
    } = this.props;

    return (      
        <div className="edit-field-section">
          <div className="edit-field">
            <div className="edit-field-title">
              Image
              {backgroundOptions.bgRandom && <span
                style={{ cursor: 'pointer', textDecoration: 'underline' , marginLeft: "10px"}} title="https://picsum.photos/1500/768"
              >
              </span>}
            </div>
            <div className="edit-field-value">
              <Switch
                checked={backgroundOptions.bgRandom}
                onChange={(e, value) => onChange(value, 'bgRandom')}
              />
            </div>
            {backgroundOptions.bgRandom && <span    
                style={{cursor: 'pointer'}}
                className="edit-field-title"            
                onClick={_ => onChange(Date.now(), 'bgRandomTimestamp')}
              >
              (new)
            </span>}
          </div>


          <div className="edit-field">
            <div className="edit-field-title">Custom Image Url</div>
            <div className="edit-field-value">       
              <input className="custom-background-image-input" defaultValue={backgroundOptions.customImage || ''} type="text" ref={r => {this.customBackgroundImageUrl = r}} onChange={this.onCustomBackgroundUrl} />
            </div>
          </div>

          <div className="edit-field half" >
              <div className="edit-field-title">Image Opacity</div>
              <div className="edit-field-value">
                <div className="edit-field-input">
                  <input 
                    type="number"
                    className="value"
                    min={0}
                    max={100}
                    value={backgroundOptions.bgOpacity}
                    onChange={e => {onChange(constrain(e.currentTarget.value, 0, 100), 'bgOpacity')}}
                  />
                  <div className="unit">px</div>
                </div>
                <Slider
                  value={backgroundOptions.bgOpacity}
                  min={0}
                  max={100}                
                  onChange={(e, sliderValue) => {
                    onChange(Math.round(sliderValue), 'bgOpacity')
                  }}
                />
              </div>
            </div>

          <div className="edit-field">
            <div className="edit-field-title">Solid Color</div>
            <div className="edit-field-value">
              <Switch
                checked={backgroundOptions.showBgColor}
                onChange={(e, value) => onChange(value, 'showBgColor')}
              />
            </div>
          </div>

          {backgroundOptions.showBgColor && (
            <div className="edit-field">
              <SketchPicker
                key="Background_Color_Picker"
                color={backgroundOptions.bgColor}
                onChange={e => {
                  onChange(e.hex, 'bgColor')
                }}
              />
            </div>
          )}
        </div>
    )
  }
}
